import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-572f20b1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
import { useRouter } from "vue-router";
import domain from "@/service/domain";
import { onBeforeMount } from "vue";
export default {
  setup(__props) {
    let list = [{
      name: "条款和协议",
      type: "list"
    }, {
      name: "资质证照",
      type: "publish"
    }];
    onBeforeMount(() => {
      document.title = '关于摩点';
    });
    const router = useRouter();
    function goProtocal(item) {
      let url = `/protocal/${item.type}`;
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}${url}`,
        webFun: () => {
          router.push({
            path: url,
            query: {}
          });
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
          return _openBlock(), _createBlock(_component_van_cell, {
            key: index,
            title: item.name,
            "is-link": "",
            class: _normalizeClass(item.type == 'divider' ? 'divider-item' : ''),
            onClick: $event => goProtocal(item)
          }, null, 8, ["title", "class", "onClick"]);
        }), 128))]),
        _: 1
      })]);
    };
  }
};